import {css, html, ReactiveController, ReactiveControllerHost} from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';


export const slidesStyle = css`
    #slide-film {
        display: flex;   
        height: 15%;
    }

    .slide {
        position: relative;
        flex-grow: 1;
        flex-basis: 0;
        border: thin solid gray;
    }

    .opaque {
        opacity: .2;
    }

    .caption {
        position: absolute;
        top: 0;
        left: .5em;
        font-size: small;
        line-height: 1;
    }
`

export class SlidesController {
    private host

    constructor(host: ReactiveControllerHost) {
        (this.host = host).addController(this)
    }

    hide(i) {
        this.host.clones[i].classList.remove('opaque')
        this.host.captions[i].classList.add('invisible')
    }

    show(i) {
        this.host.clones[i].classList.add('opaque')
        this.host.captions[i].classList.remove('invisible')
    }

}